<template>
    <img :src="img.filename" :class="imageClass" :alt="imageAlt" />
</template>

<script setup lang="ts">
import type { SbImage } from '@/components/StoryblokComponent.vue';

defineProps<{ img: SbImage; imageClass?: string; imageAlt?: string }>();
</script>
